import microuniversoApi from "app/api/microuniversoApi"
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse"
import { FiltroPesquisaClientes } from "app/types/cliente/FiltroPesquisaClientes"
import { tratamentoErroPadrao } from "app/use-cases"
import { Dict } from "app/utils/Dict"
import globalMU from "globalMU"
import * as R from "ramda"
import React, { useEffect, useRef, useState } from "react"
import { PesquisarClienteContainer } from "../pesquisa-cliente/PesquisarClienteContainer"
import { renderizarComponentReact } from "../renderizarOuRemoverComponentReact"
import { OrcamentoUnificacao, UnificacaoDeOrcamentos, UnificacaoDeOrcamentosFiltroPesquisa } from "./UnificacaoDeOrcamentos"
import { Parametro } from "app/types/Parametro"
import { obterParametros } from "app/use-cases/parametro/obterParametros"

export type UnificacaoDeOrcamentosContainerProps = { // 427169
    clienteSelecionado: FiltroPesquisaClientes,
    dataInicial: string,
    dataFinal: string,
    numeroPagina?: number
}

declare const window: any;

export const UnificacaoDeOrcamentosContainer = (props: UnificacaoDeOrcamentosContainerProps) => { // 427169
    const passosInterno = useRef<Dict<string, () => void>>(new Dict())
    const onRenderizarUnificacaoDeOrcamentosContainer = () => renderizarComponentReact(<UnificacaoDeOrcamentosContainer
        clienteSelecionado={filtro.ClienteSelecionado}
        dataInicial={filtro.DataInicial}
        dataFinal={filtro.DataFinal}
        numeroPagina={filtro.NumeroPagina}
    />, "unificacao-de-orcamentos-region", true)
    const [filtro, setFiltro] = useState<UnificacaoDeOrcamentosFiltroPesquisa>({
        ClienteSelecionado: props.clienteSelecionado,
        DataInicial: props.dataInicial ?? globalMU.converterObjetoDateParaDataFormatoPT(new Date()),
        DataFinal: props.dataFinal ?? globalMU.converterObjetoDateParaDataFormatoPT(new Date()),
        NumeroPagina: props.numeroPagina ?? 1,
        TamanhoPagina: 0 // usar default sistema

    })
    const [listaOrcamento, setListaOrcamento] = useState<PagedMessageResponse<OrcamentoUnificacao>>({})
    const [orcamentosSelecionados, setOrcamentosSelecionados] = useState<number[]>([])
    const [codigoFilialUsuarioLogado, setCodigoFilialUsuarioLogado] = useState("")
    const [parametros, setParametros] = useState<Parametro[]>([])
    const [oidUsuarioLogado, setOidUsuarioLogado] = useState<number>(0)
    const [primeiroPedidoSelecionado, setPrimeiroPedidoSelecionado ] = useState<OrcamentoUnificacao>(null)
    const [processandoUnificacao, setProcessandoUnificacao] = useState(false)

    useEffect(() => {
        var controleExclusividadeUnificacaodeOrcamentosHub = $.connection.controleExclusividadeUnificacaoDeOrcamentosHub
        controleExclusividadeUnificacaodeOrcamentosHub.client.pong = () => {
            console.log('controleExclusividadeUnificacaodeOrcamentosHub => pong')
        }
        $.connection.hub.start().done(function () {
            controleExclusividadeUnificacaodeOrcamentosHub.server.ping()
        })
        $.connection.hub.disconnected(function () {
            //desconectarVendedorUnificacao()
            console.log("$.connection.hub.disconnected")
            setOrcamentosSelecionados([])
        });

        if (orcamentosSelecionados.length === 0) {
            setPrimeiroPedidoSelecionado(null)
        }
        else if (orcamentosSelecionados.length === 1 && orcamentosSelecionados[0] != null) 
        {
            const primeiro = (listaOrcamento?.Entities ?? []).filter((o) => orcamentosSelecionados.includes(o.NumeroPedido))
            setPrimeiroPedidoSelecionado(primeiro[0])
        } 
    }, [orcamentosSelecionados.length])

    useEffect(() => {
        obterOidUsuario()
        atualizarParametros()
        atualizarCodigoFilialUsuarioLogado()
        passosInterno.current.set("Unificação De Orçamentos", onRenderizarUnificacaoDeOrcamentosContainer)
        validarConfiguracaoCorreta()
    }, [])

    const valorParametro = (nome: string) => parametros.find((p) => p.Nome == nome)?.Valor;

    const desconectarVendedorUnificacao = async () => {
        await microuniversoApi.Vendedor.desconectar()
    }

    const atualizarParametros = async () => {
        setParametros(
            await obterParametros({
                nomes: [
                    "PERMITE_UNIFICACAO_ORCAMENTO_SOMENTE_DA_FILIAL_USUARIO", // por filial
                    "ORCAMENTO_CONTROLA_VENDEDOR_SETORES", // por empresa
                    "UNIFICACAO_ORCAMENTO_VENDEDOR_PADRAO", // por empresa
                ],
            })
        );
    };


    const atualizarCodigoFilialUsuarioLogado = async () => {
        setCodigoFilialUsuarioLogado(
            await microuniversoApi.Usuario.ObterCodigoFilialUsuarioLogado()
        )
    }

    const obterOidUsuario = async () => {
        setOidUsuarioLogado(await microuniversoApi.Usuario.obterOid());
    }

    const validarConfiguracaoCorreta = async () => {
        if (valorParametro("ORCAMENTO_CONTROLA_VENDEDOR_SETORES") === "S") {
            var vendedorPadrao = valorParametro("UNIFICACAO_ORCAMENTO_VENDEDOR_PADRAO")
            if (vendedorPadrao !== null || vendedorPadrao !== undefined) {
                globalMU.showErrorMessage(`Vendedor padrão para orçamento unificado não informado ou inválido`)
            }
        }
    }

    const toggleOrcamentoSelecionado = async (numeroPedido: number) => {
        globalMU.blockUI()
        try {
            const orcamentosJaSelecionados = (listaOrcamento?.Entities ?? []).filter((o) => orcamentosSelecionados.includes(o.NumeroPedido))
            await _validarPermiteSelecionarPedido(numeroPedido, orcamentosJaSelecionados)
        }
        finally {
            globalMU.unblockUI()
        }
    };

    const _validarPermiteSelecionarPedido = async (numeroPedido: number, listaOrcamentosComNumeroPedidoValidando: OrcamentoUnificacao[]) => {
        if (orcamentosSelecionados.includes(numeroPedido)) {
            try {
                const resp = await microuniversoApi.Orcamento.RemoverControleExclusividade(numeroPedido, false)
                

                resp && setOrcamentosSelecionados(
                    R.filter((e) => e != numeroPedido, orcamentosSelecionados)
                );
                
                return true
            } catch {
                // ignorar erro globalMU.showErrorMessage(`Não foi possivel liberar o Controle de Exclusividade do Orçamento (${numeroPedido})`)
                // ignorar erro return false
            }

        }
        else 
        {
            
            const permiteSelecionar = await _permitirSelecionarPedido(numeroPedido, listaOrcamentosComNumeroPedidoValidando)
            
            if (permiteSelecionar) {
                try {
                    const resp = await microuniversoApi.Orcamento.DefinirControleExclusividade(numeroPedido, "Y")
                    resp && setOrcamentosSelecionados(orcamentosSelecionados.concat(numeroPedido));
                    return true
                } catch {
                    globalMU.showErrorMessage(`Orçamento [${numeroPedido}] está em uso por outro usuário`)
                    return false
                }
            }
        }
    };

    const _removerTodosSelecionadosExclusividade = async () => {
        const removeSelecionadoExclusividade = async (numeroPedido) => {
            try {
                const resp = await microuniversoApi.Orcamento.RemoverControleExclusividade(numeroPedido, false)
                resp && setOrcamentosSelecionados(orcamentosSelecionados.filter(n => n != numeroPedido))
            } catch {
                // ignorar globalMU.showErrorMessage(`Não foi possivel liberar o Controle de Exclusividade do Orçamento (${numeroPedido})`)
            }
            return numeroPedido
        }
        const numerosRemovidos = await Promise.all(orcamentosSelecionados.map(removeSelecionadoExclusividade))
        setOrcamentosSelecionados(
            orcamentosSelecionados.filter(numeroPedido => !numerosRemovidos.includes(numeroPedido))
        )
    }

    const _adicionarTodosSelecionadosExclusividade = async () => {
        const adicionaSelecionadoExclusividade = async (numeroPedido, listaOrcamentosComNumeroPedidoValidando: PagedMessageResponse<OrcamentoUnificacao>) => {
            try {
                if (await _validarPermiteSelecionarPedido(numeroPedido, (listaOrcamentosComNumeroPedidoValidando?.Entities ?? [])))
                    return numeroPedido

                return null
            }
            catch
            {

                return null
            }
        }

        const filtroPesquisa: UnificacaoDeOrcamentosFiltroPesquisa = { ...filtro, NumeroPagina: 1, TamanhoPagina: listaOrcamento?.RowsCount ?? 0 }
        const resposta = await microuniversoApi.Orcamento.obterListaOrcamentosUnificaveis(filtroPesquisa)
        setOrcamentosSelecionados((await Promise.all(resposta?.Entities?.map(o => adicionaSelecionadoExclusividade(o.NumeroPedido, resposta)))).filter(n => n != null))
    }

    const toggleSelecionarTodos = async () => {
        try {
            globalMU.blockUI();
            if (orcamentosSelecionados.length <= 0) {
                //if (orcamentosSelecionados.length < listaOrcamento?.RowsCount ?? 0) {
                await _adicionarTodosSelecionadosExclusividade()
            } else {
                await _removerTodosSelecionadosExclusividade()
            }
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    };

    const onPesquisarCliente = async () => {
        renderizarComponentReact(
            <PesquisarClienteContainer
                regiaoRenderizada="unificacao-de-orcamentos-region"
                passos={passosInterno.current}
                onVoltar={onRenderizarUnificacaoDeOrcamentosContainer}
                consultar
                onSelecionarClienteCallback={(cliente) => {
                    renderizarComponentReact(<UnificacaoDeOrcamentosContainer
                        clienteSelecionado={{ Codigo: cliente.Codigo, Nome: cliente.Nome }}
                        dataInicial={filtro.DataInicial}
                        dataFinal={filtro.DataFinal}
                        numeroPagina={filtro.NumeroPagina} />, "unificacao-de-orcamentos-region", true)
                }}
            />, "unificacao-de-orcamentos-region", true)
    }

    const onExcluirClienteSelecionado = async () => {
        try {
            globalMU.blockUI();
            setFiltro({ ...filtro, ClienteSelecionado: {} })
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const onPesquisarOrcamentosParaUnificacao = async (numeroPagina: number) => {
        try {
            globalMU.blockUI();
            if (numeroPagina == -1) {
                await _removerTodosSelecionadosExclusividade()
                numeroPagina = 1
            }
            const filtroPesquisa = { ...filtro, NumeroPagina: numeroPagina }
            setFiltro(filtroPesquisa)
            const resposta = await microuniversoApi.Orcamento.obterListaOrcamentosUnificaveis(filtroPesquisa)
            setListaOrcamento(resposta)
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const onProcessarUnificacaoOrcamentos = async () => {
        try {
            globalMU.blockUI();
            setProcessandoUnificacao(true)
            //var lista = listaOrcamento?.Entities?.map(p => p.NumeroPedido)
            //const resposta = await microuniversoApi.Orcamento.unificarOrcamentos(lista)
            const resposta = await microuniversoApi.Orcamento.unificarOrcamentos(orcamentosSelecionados)

            if (resposta > 7) {
                globalMU.showSuccessMessage(`Orçamento unificado criado com sucesso!<br\><br\>Criado pedido unificado: ${resposta}<br\><br\>Orçamento será aberto para edição!`)

                window.location = "/Orcamento/EditarOrcamentoUnificado?numeroOrcamento=" + resposta;
            }
            else {
                setProcessandoUnificacao(false)
            }
        } catch (e) {
            tratamentoErroPadrao(e);
            setProcessandoUnificacao(false)
        } finally {
            globalMU.unblockUI();
        }
    }

    const onGerarOrcamentoPdf = async (numeroOrcamento: number) => {
        try {
            globalMU.blockUI();
            const resposta = await microuniversoApi.Orcamento.GerarPdfTemplatePadrao(numeroOrcamento,
                'ORCAMENTO_FINALIZAR',
                'IMPRIMIR_ORCAMENTO')

            var file = new Blob([resposta.data], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            var popUp = window.open(fileURL, '_blank', "Consulta Orçamento");
            if (popUp == null || typeof (popUp) == 'undefined') {
                alert('Para visualizar o orçamento desabilite o bloqueio de popup neste navegador para este site.');
            }
            else {
                popUp.focus();
            }
        } catch (e) {
            if (oidUsuarioLogado <= 10)
                globalMU.showErrorMessage(`Não foi possível visualizar o orçamento!<br\><br\>Verifique se existe modelo configurado como "Padrão" para o finalizar orçamentos`)
            else
                globalMU.showErrorMessage(`Não foi possível visualizar o orçamento!`)
            //tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const _permitirSelecionarPedido = async (numeroPedido: number, listaOrcamentosComNumeroPedidoValidando: OrcamentoUnificacao[]) => {

        let primeiroPedido = primeiroPedidoSelecionado
        if (primeiroPedido == null && listaOrcamentosComNumeroPedidoValidando?.length > 0) 
        {
            primeiroPedido = listaOrcamentosComNumeroPedidoValidando[0]
        }
        if (primeiroPedido != null) {
            const pedidoSelecionado = listaOrcamento?.Entities?.find((pedido) => pedido.NumeroPedido == numeroPedido)
            if (valorParametro("PERMITE_UNIFICACAO_ORCAMENTO_SOMENTE_DA_FILIAL_USUARIO") !== "S") {
                if (pedidoSelecionado.TemFilialTransferencia) {
                    globalMU.showErrorMessage(`Orçamento[${numeroPedido}] - Há itens com filial de retirada e filial de transferência.`)
                    return false;
                }
                if (pedidoSelecionado.CodigoFilial != codigoFilialUsuarioLogado && pedidoSelecionado.TemFilialRetiradaDiferente) {
                    globalMU.showErrorMessage(`Orçamento[${numeroPedido}] - Filial de venda do orçamento diferente da filial de venda padrão para orçamento unificado [${codigoFilialUsuarioLogado}].`)
                    return false;
                }
            }

            // valida se tpo é igual
            var tpo = pedidoSelecionado.Tpo?.trimEnd()
            if (primeiroPedido.Tpo.trimEnd() !== tpo) {
                globalMU.showErrorMessage(`O TPO dos orçamentos deve ser o mesmo`)
                return false;
            }

            if (!(pedidoSelecionado.OidFormaDePagar == primeiroPedido.OidFormaDePagar && pedidoSelecionado.TiposDocumentos == primeiroPedido.TiposDocumentos))
            {
                globalMU.showErrorMessage(`A condição de pagamento e tipos de documento devem ser iguais.`)
                return false;
            }

            if (orcamentosSelecionados?.length > 0) {
                await microuniversoApi.Orcamento.ValidarProdutoComPrecoDiferente(numeroPedido, orcamentosSelecionados);
            }
        }
        return true
    }

    return (
        <>
            <UnificacaoDeOrcamentos
                colorBackgroundSelecionada={globalMU.sessionStorage.getData('UsuarioLogado')?.CorFundo}
                colorTextoSelecionada={globalMU.sessionStorage.getData('UsuarioLogado')?.CorTexto}
                filtro={filtro}
                listaOrcamentos={listaOrcamento}
                orcamentosSelecionados={orcamentosSelecionados}
                processandoUnificacao={processandoUnificacao}
                totalRegistros={listaOrcamento?.RowsCount ?? 0}
                onPesquisarCliente={onPesquisarCliente}
                onExcluirClienteSelecionado={onExcluirClienteSelecionado}
                onPesquisarOrcamentosParaUnificacao={() => { onPesquisarOrcamentosParaUnificacao(-1) }}
                onConsultarOrcamento={(numeroPedido: number) => { onGerarOrcamentoPdf(numeroPedido) }}
                onProcessarUnificacaoOrcamentos={onProcessarUnificacaoOrcamentos}
                onSelecionarTodos={toggleSelecionarTodos}
                onToggleOrcamentoSelecionado={toggleOrcamentoSelecionado}
                onChangeDataInicial={(data: string) => setFiltro({ ...filtro, DataInicial: data })}
                onChangeDataFinal={(data: string) => setFiltro({ ...filtro, DataFinal: data })}
                onAlteradoPagina={(numeroPagina: number) => onPesquisarOrcamentosParaUnificacao(numeroPagina)}
            />
        </>

    )
}

window.UnificacaoDeOrcamentosContainer = UnificacaoDeOrcamentosContainer
